import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import FormSelect from "Common/Custom/FormSelect";
import propTypes from "prop-types";
import { getSelectOptions } from "utils/optionHelper";

const EditSettingForm = ({
  values = {},
  errors = {},
  handleChange = () => { },
  handleSubmit = () => { },
  loading = false,
  title = "Update Setting",
  fields = [],
  VehicleTypeOptions = [],
  ZonesTypesOptions = [],
  TaxOptions = [],
}) => {

  const optionConfig = {
    vehicle_list_id: {
      list: VehicleTypeOptions,
      valueKey: "vehicle_list_id",
      labelKey: "vehicle_type"
    },
    zone_list_id: {
      list: ZonesTypesOptions,
      valueKey: "zone_list_id",
      labelKey: "zone_type"
    },
    tax_id: {
      list: TaxOptions,
      valueKey: "tax_id",
      labelKey: "tax_name"
    }
  };

  return (
    <PageBody
      headerchildren={<HeadingOne>{title}</HeadingOne>}
      onSubmit={handleSubmit}
    >
      {fields.map((field) => {

        if (field.type === "select") {
          return (
            <FormSelect
              key={field.name}
              field={field}
              value={String(values[field.name] ?? "")}
              handleChange={handleChange}
              options={getSelectOptions(field.name, optionConfig)}
              error={errors[field.name]}
            />
          );
        }
        
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label={`Update ${title}`}
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditSettingForm;
